import React from "react";
import styled from "styled-components";
import LogoUploadPanel from "./LogoUploadPanel";

const Drawer = styled.div`
  position: fixed;
  top: 82px;
  right: 0;
  height: 100%;
  width: 360px;
  background: #fff;
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
  transition: transform 0.25s ease;
`;

const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
`;

const DrawerTitle = styled.div`
  font-size: 24px;
  font-weight: 400;
  line-height: 24px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #4c8cee;
  line-height: 1;
  padding: 0;

  &:hover {
    color: #3a6db5;
  }
`;

const DrawerBody = styled.div`
  flex: 1;
  padding: 20px;
  overflow-y: auto;
`;

const DesignDrawer = ({ open, onClose, onSaved }) => {
  return (
    <>
      <Drawer open={open}>
        <DrawerHeader>
          <DrawerTitle>Card Design</DrawerTitle>
          <CloseButton onClick={onClose}>&#x2715;</CloseButton>
        </DrawerHeader>
        <DrawerBody>
          <LogoUploadPanel open={open} onClose={onClose} onSaved={onSaved} />
        </DrawerBody>
      </Drawer>
    </>
  );
};

export default DesignDrawer;
